import { lazy } from "../components/common/lazy";

export const QualityImage = lazy(
  () =>
    import(
      /* webpackChunkName: "quality-image" */ "../components/component-quality/quality-verification-image"
    )
);
export const QualityAddress = lazy(
  () =>
    import(
      /* webpackChunkName: "quality-address" */ "../components/component-quality/quality-verification-address"
    )
);
export const AddListing = lazy(
  () =>
    import(
      /* webpackChunkName: "add-listing" */ "../components/component-add-listing"
    )
);
export const AddListingV2 = lazy(
  () =>
    import(
      /* webpackChunkName: "add-listing-v2" */ "../components/component-add-listing-v2"
    )
);

export const AgencyBranch = lazy(
  () =>
    import(
      /* webpackChunkName: "agency-branch" */ "../components/component-agency-branch"
    )
);

export const AllocationPlan = lazy(
  () =>
    import(
      /* webpackChunkName: "allocation-plan" */ "../components/component-plans/allocation"
    )
);

export const AllocationPage = lazy(
  () =>
    import(
      /* webpackChunkName: "allocation-page" */ "../components/component-allocation/allocation-page"
    )
);

export const AllocationIndividual = lazy(
  () =>
    import(
      /* webpackChunkName: "allocation-individual" */ "../components/component-allocation/individual"
    )
);

export const ListingPage = lazy(
  () =>
    import(
      /* webpackChunkName: "listing-page" */ "../components/component-listing"
    )
);

export const AllocationReport = lazy(
  () =>
    import(
      /* webpackChunkName: "allocation-report" */ "../components/component-allocation/report"
    )
);

export const Allocations = lazy(
  () =>
    import(
      /* webpackChunkName: "allocations" */ "../components/component-allocation/allocations"
    )
);

export const Watermark = lazy(
  () =>
    import(
      /* webpackChunkName: "watermark" */ "../components/component-watermark"
    )
);

export const Plans = lazy(
  () =>
    import(
      /* webpackChunkName: "plans" */ "../components/component-plans/index.malaysia"
    )
);

export const Reportings = lazy(
  () =>
    import(
      /* webpackChunkName: "reportings" */ "../components/component-reportings"
    )
);

export const Quality = lazy(
  () =>
    import(
      /* webpackChunkName: "qualityDashboard" */ "../components/component-quality/quality-dashboard"
    )
);

export const ListingTypeView = lazy(
  () =>
    import(
      /* webpackChunkName: "add-listing-type" */ "../components/component-add-listing/listing-type"
    )
);
export const ListingDetailsView = lazy(
  () =>
    import(
      /* webpackChunkName: "add-listing-details" */ "../components/component-add-listing/listing-type"
    )
);
export const LocationInfo = lazy(
  () =>
    import(
      /* webpackChunkName: "add-listing-location" */ "../components/component-add-listing/location-info"
    )
);
export const LocationInfoV2 = lazy(
  () =>
    import(
      /* webpackChunkName: "add-listing-v2-location" */ "../components/component-add-listing-v2/location"
    )
);

export const PropertyDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "add-listing-details" */ "../components/component-add-listing/property-details"
    )
);

export const PropertyDetailsV2 = lazy(
  () =>
    import(
      /* webpackChunkName: "add-listing-details" */ "../components/component-add-listing-v2/property-details"
    )
);
export const DescriptionAndMedia = lazy(
  () =>
    import(
      /* webpackChunkName: "add-listing-description-and-media" */ "../components/component-add-listing/description-and-media"
    )
);
export const SuccessPage = lazy(
  () =>
    import(
      /* webpackChunkName: "add-listing-success" */ "../components/component-add-listing/SuccessPage"
    )
);
export const PreviewListing = lazy(
  () =>
    import(
      /* webpackChunkName: "add-listing-preview" */ "../components/component-add-listing/preview-listing"
    )
);
export const UpgradeAndReview = lazy(
  () =>
    import(
      /* webpackChunkName: "add-listing-upgrade-and-review" */ "../components/component-add-listing/upgrade-and-review"
    )
);

export const EditListing = lazy(
  () =>
    import(
      /* webpackChunkName: "edit-listing" */ "../components/component-edit-listing"
    )
);

export const EditOfUpgrade = lazy(
  () =>
    import(
      /* webpackChunkName: "edit-listing-upgrade" */ "../components/component-edit-listing/upgrade"
    )
);

export const AgencyBranchCreation = lazy(
  () =>
    import(
      /* webpackChunkName: "agency-creation" */ "../components/component-agency-branch/agency-branch-creation"
    )
);
export const AgencyBranchEdit = lazy(
  () =>
    import(
      /* webpackChunkName: "agency-edit" */ "../components/component-agency-branch/agency-branch-edit"
    )
);
export const AgencyBranchList = lazy(
  () =>
    import(
      /* webpackChunkName: "agency-list" */ "../components/component-agency-branch/agency-branch-list"
    )
);

export const Listings = lazy(
  () =>
    import(
      /* webpackChunkName: "listings" */ "../components/component-listings"
    )
);
export const BatchUpload = lazy(
  () =>
    import(
      /* webpackChunkName: "batch-upload" */ "../components/component-listings/batch-upload"
    )
);
export const Overview = lazy(
  () =>
    import(
      /* webpackChunkName: "overview" */ "../components/component-listing/components/overview"
    )
);
export const Reporting = lazy(
  () =>
    import(
      /* webpackChunkName: "reporting" */ "../components/component-reporting/index.malaysia"
    )
);

export const Performances = lazy(
  () =>
    import(
      /* webpackChunkName: "reporting-performance" */ "../components/component-reportings/components/performance"
    )
);

export const SpecialistReport = lazy(
  () =>
    import(
      /* webpackChunkName: "reporting-specialist" */ "../components/component-specialist-report"
    )
);

export const EnquirySettings = lazy(
  () =>
    import(
      /* webpackChunkName: "enquiry-settings" */ "../components/component-enquiry-settings"
    )
);
export const Subscription = lazy(
  () =>
    import(
      /* webpackChunkName: "subscription" */ "../components/component-plans/subscription"
    )
);

export const CreditUsage = lazy(
  () =>
    import(
      /* webpackChunkName: "creditUsage" */ "../components/component-plans/CreditUsage"
    )
);

export const Leads = lazy(
  () =>
    import(
      /* webpackChunkName: "leads" */ "../components/component-leads/lead-landing"
    )
);

export const LeadsV2 = lazy(
  () =>
    import(
      /* webpackChunkName: "leads-v2" */ "../components/component-leads/v2/index"
    )
);

export const LeadDetailV2 = lazy(
  () =>
    import(
      /* webpackChunkName: "lead-detail-v2" */ "../components/component-leads/v2/leadDetail"
    )
);

export const LeadInterestShownHistory = lazy(
  () =>
    import(
      /* webpackChunkName: "lead-interest-shown-history" */ "../components/component-leads/v2/interestShownHistory"
    )
);

export const Agentools = lazy(
  () =>
    import(
      /* webpackChunkName: "agentools" */ "../components/component-agentools"
    )
);

export const LeadDetail = lazy(
  () =>
    import(
      /* webpackChunkName: "lead-detail" */ "../components/component-leads/lead-detail"
    )
);

export const PropertyWanted = lazy(
  () =>
    import(
      /* webpackChunkName: "property-wanted" */ "../components/component-property-wanted"
    )
);

export const Fsbo = lazy(
  () => import(/* webpackChunkName: "fsbo" */ "../components/component-fsbo")
);

export const MarketAnalytics = lazy(
  () =>
    import(
      /* webpackChunkName: "market-analytics" */ "../components/component-market-analytics/"
    )
);

export const MarketWatch = lazy(
  () =>
    import(
      /* webpackChunkName: "market-watch" */ "../components/component-market-watch"
    )
);

export const ConvertAdCredits = lazy(
  () =>
    import(
      /* webpackChunkName: "convert-ad-credits" */ "../components/component-convert-ad-credits"
    )
);

export const Reports = lazy(
  () =>
    import(/* webpackChunkName: "reports" */ "../components/component-reports")
);

export const Dashboard = lazy(
  () =>
    import(
      /* webpackChunkName: "Dashboard" */ "../components/component-dashboard"
    )
);
export const Notification = lazy(
  () =>
    import(
      /* webpackChunkName: "Notification" */ "@customer-tools-web/component-header-footer/lib/header/components/Notification"
    )
);

export const AnnouncementsPage = lazy(
  () =>
    import(
      /* webpackChunkName: "AnnouncementsPage" */ "../components/component-dashboard/components/AnnouncementsPage"
    )
);
export const AnnouncementDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "AnnouncementDetails" */ "../components/component-dashboard/components/AnnouncementDetails"
    )
);
export const ScheduledManager = lazy(
  () =>
    import(
      /* webpackChunkName: "scheduled-manager" */ "../components/component-scheduled-manager"
    )
);

export const EnquiryManagement = lazy(
  () =>
    import(
      /* webpackChunkName: "enquiry-management" */ "../components/component-enquiry-management"
    )
);

export const EnquiryManagementOverview = lazy(
  () =>
    import(
      /* webpackChunkName: "enquiry-management-overview" */ "../components/component-enquiry-management/overview"
    )
);

export const Enquiries = lazy(
  () =>
    import(
      /* webpackChunkName: "enquiries" */ "../components/component-enquiry-management/enquiries"
    )
);

export const Blacklists = lazy(
  () =>
    import(
      /* webpackChunkName: "blacklists" */ "../components/component-enquiry-management/blacklists"
    )
);

export const RateLimits = lazy(
  () =>
    import(
      /* webpackChunkName: "rate-limits" */ "../components/component-enquiry-management/rateLimits"
    )
);

export const Brickz = lazy(
  () =>
    import(/* webpackChunkName: "brickz" */ "../components/component-brickz")
);

export const IQAgent = lazy(
  () =>
    import(
      /* webpackChunkName: "iq-agent" */ "../components/component-iq-agent"
    )
);

export const CreateAnnouncement = lazy(
  () =>
    import(
      /* webpackChunkName: "create-announcement" */ "../components/component-announcement/components/CreateAnnouncement"
    )
);

export const AnnouncementListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "announcement-list" */ "../components/component-announcement"
    )
);

export const EditAnnouncement = lazy(
  () =>
    import(
      /* webpackChunkName: "edit-announcement" */ "../components/component-announcement/components/EditAnnouncement"
    )
);

export const PreviewAnnouncement = lazy(
  () =>
    import(
      /* webpackChunkName: "edit-announcement" */ "../components/component-announcement/components/PreviewAnnouncement"
    )
);

export const SpecialistSlotList = lazy(
  () =>
    import(
      /* webpackChunkName: "area-condo-specialist-slot-list" */ "../components/component-area-condo-specialist/admin/components/SlotList/index"
    )
);

export const SpecialistSlotEdit = lazy(
  () =>
    import(
      /* webpackChunkName: "area-condo-specialist-slot-edit" */ "../components/component-area-condo-specialist/admin/components/SlotEdit/index"
    )
);

export const SpecialistSlotEditSuccess = lazy(
  () =>
    import(
      /* webpackChunkName: "area-condo-specialist-slot-edit-success" */ "../components/component-area-condo-specialist/admin/components/SlotEditSuccess/index"
    )
);

export const AreaCondoSpecialist = lazy(
  () =>
    import(
      /* webpackChunkName: "area-condo-specialist" */ "../components/component-area-condo-specialist/common/list"
    )
);

export const AreaCondoSpecialistAdd = lazy(
  () =>
    import(
      /* webpackChunkName: "area-condo-specialist-add" */ "../components/component-area-condo-specialist/common/add"
    )
);

export const AreaCondoSpecialistAddSuccess = lazy(
  () =>
    import(
      /* webpackChunkName: "area-condo-specialist-add-success" */ "../components/component-area-condo-specialist/admin/components/SpecialistAddSuccess/index"
    )
);

export const AreaCondoSpecialistUpgradeListing = lazy(
  () =>
    import(
      /* webpackChunkName: "area-condo-specialist-upgrade-listing" */ "../components/component-area-condo-specialist/selfServe/upgradeListing"
    )
);
export const CreditBrickz = lazy(
  () =>
    import(
      /* webpackChunkName: "credit-brickz" */ "../components/component-credit-brickz/index"
    )
);

export const PaymentResult = lazy(
  () =>
    import(
      /* webpackChunkName: "payment-result" */ "../components/component-payment-result/index"
    )
);

export const PaymentHistory = lazy(
  () =>
    import(
      /* webpackChunkName: "payment-history" */ "../components/component-payment-history/index"
    )
);

export const SubscriptionRenewal = lazy(
  () =>
    import(
      /* webpackChunkName: "subscription-renewal" */ "../components/component-subscription-renewal/index"
    )
);

export const DynamicPricing = lazy(
  () =>
    import(
      /* webpackChunkName: "dynamic-pricing" */ "../components/component-dynamic-pricing/index"
    )
);
